export default __webpack_public_path__ + "static/media/kitchen1-768w.4a7fc95f.png";